// Types
import type { TSelectOptionProps, TSelectProps, TSelectSize, TSelectStatus, TSelectVariant } from './Select.type';

export const SELECT_CLEAR_SEARCH_ID = 'select-clear-search';
export const SELECT_OPTION_ROOT_ID = 'select-option-root';
export const SELECT_OPTION_TIMEOUT = 300;

export const SELECT_SIZES: TSelectSize[] = ['sm', 'md', 'lg'];
export const SELECT_SIZE: { [key in TSelectSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
};

export const SELECT_STATUSES: TSelectStatus[] = ['default', 'error', 'success'];
export const SELECT_STATUS: { [key in TSelectStatus]: key } = {
	default: 'default',
	error: 'error',
	success: 'success',
};

export const SELECT_VARIANTS: TSelectVariant[] = ['inline', 'outline'];
export const SELECT_VARIANT: { [key in TSelectVariant]: key } = {
	inline: 'inline',
	outline: 'outline'
};

export const SELECT_OPTION_DEFAULT_PROPS: TSelectOptionProps = {
	options: [],
	size: SELECT_SIZE.md,
}

export const SELECT_DEFAULT_PROPS: TSelectProps = {
	options: [],
	size: SELECT_SIZE.md,
	status: SELECT_STATUS.default,
	variant: SELECT_VARIANT.outline,
};
